var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _line66, _line67, _line68, _line69, _line70, _line71, _line72, _line73, _line74, _line75, _line76, _line77, _line78, _line79, _line80, _line81, _line82, _line83, _line84, _line85, _line86, _line87, _line88, _line89, _line90, _line91, _line92, _line93, _line94, _line95, _line96, _line97, _line98, _line99;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPls2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 268.83 139.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2{fill:#812990;}.cls-3{fill:#6b7b84;}.cls-4,.cls-5{fill:none;stroke:#6b7b84;stroke-miterlimit:10;stroke-width:0.5px;}.cls-5{stroke-dasharray:1.98 1.98;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M194.38,10.34h-1.66V15h-1v-4.7h-1.67v-1h4.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.46,9.37V15h-1V11l-1.87,2.89L195.76,11v4h-1V9.37h1.07l1.77,2.75,1.78-2.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45,24.07V25.9a13,13,0,0,0-3.22-1.74,12,12,0,0,0-4.18-.68,12.59,12.59,0,0,0-4.88.93A12.1,12.1,0,0,0,28.84,44a11.72,11.72,0,0,0,3.87,2.58,12.59,12.59,0,0,0,4.88.93h.48A13.16,13.16,0,0,0,43,46.6V40.11l0,0a6.79,6.79,0,0,1-2.26,1.44,7.27,7.27,0,0,1-2.64.48A8.32,8.32,0,0,1,37,42h0a7.49,7.49,0,0,1-1.55-.39,6.21,6.21,0,0,1-2.23-1.44,6.32,6.32,0,0,1,0-9.26,6.9,6.9,0,0,1,2.23-1.42,7.32,7.32,0,0,1,2.67-.5A6.86,6.86,0,0,1,43,30.87a6.2,6.2,0,0,1,2,4.65v12h5.76V24.07Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.58,47.52,7.8,35.2V47.52H2V15H7.8V27.32L20.58,15.08h8.17L11.89,31.26,28.75,47.52Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.74,23.48a10.58,10.58,0,0,1,4.28.84,9.84,9.84,0,0,1,3.29,2.33,10.53,10.53,0,0,1,2.11,3.44,11.68,11.68,0,0,1,.75,4.2V47.52H70.4V34.29a4.85,4.85,0,0,0-1.68-3.78,5.81,5.81,0,0,0-7.92,0,5,5,0,0,0-1.64,3.78V47.52H53.4V24.12h5.76v1.73a11.5,11.5,0,0,1,2.93-1.71A9.68,9.68,0,0,1,65.74,23.48Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.89,24.12a10.19,10.19,0,0,1,3.87-.69v5.48a6.9,6.9,0,0,0-4.91,1.91,6.39,6.39,0,0,0-2,4.66v12h-5.77V24.07h5.77v1.78A12.09,12.09,0,0,1,143.89,24.12Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M160.8,23.48a13.13,13.13,0,0,1,4.95.93,13,13,0,0,1,4,2.58,12.05,12.05,0,0,1,2.72,3.83,11.44,11.44,0,0,1,1,4.7,11.32,11.32,0,0,1-1,4.66A11.94,11.94,0,0,1,169.78,44a12.64,12.64,0,0,1-4,2.58,13.64,13.64,0,0,1-9.9,0,12.53,12.53,0,0,1-4-2.58,11.94,11.94,0,0,1-2.72-3.83,11.16,11.16,0,0,1-1-4.66,11.28,11.28,0,0,1,1-4.7A12.05,12.05,0,0,1,151.82,27a12.88,12.88,0,0,1,4-2.58A13.13,13.13,0,0,1,160.8,23.48Zm0,5.47a6.84,6.84,0,0,0-4.9,1.92,6.51,6.51,0,0,0,2.23,10.7,7.52,7.52,0,0,0,2.67.48,7.27,7.27,0,0,0,2.64-.48,6.79,6.79,0,0,0,2.26-1.44,6.32,6.32,0,0,0,0-9.26A7.06,7.06,0,0,0,160.8,29Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.78,23.48a13.13,13.13,0,0,1,4.95.93,13,13,0,0,1,4,2.58,12.21,12.21,0,0,1,2.72,3.83,11.44,11.44,0,0,1,1,4.7,11.32,11.32,0,0,1-1,4.66A12.1,12.1,0,0,1,196.76,44a12.64,12.64,0,0,1-4,2.58,13.64,13.64,0,0,1-9.9,0,12.69,12.69,0,0,1-4-2.58,11.92,11.92,0,0,1-2.71-3.83,11.17,11.17,0,0,1-1-4.66,11.29,11.29,0,0,1,1-4.7A12,12,0,0,1,178.79,27a12.92,12.92,0,0,1,9-3.51Zm0,5.47a6.84,6.84,0,0,0-4.9,1.92,6.51,6.51,0,0,0,2.23,10.7,7.52,7.52,0,0,0,2.67.48,7.27,7.27,0,0,0,2.64-.48,6.89,6.89,0,0,0,2.26-1.44,6.32,6.32,0,0,0,0-9.26A7.08,7.08,0,0,0,187.78,29Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.12,24.07V25.9a12.85,12.85,0,0,0-3.22-1.74,12,12,0,0,0-4.18-.68,12.59,12.59,0,0,0-4.88.93,11.8,11.8,0,0,0-6.41,6.41,12.08,12.08,0,0,0-.91,4.7,12,12,0,0,0,.91,4.66A11.79,11.79,0,0,0,110,44a11.58,11.58,0,0,0,3.86,2.58,12.59,12.59,0,0,0,4.88.93h.48a13.16,13.16,0,0,0,4.92-.92V40.11l0,0a6.79,6.79,0,0,1-2.26,1.44,7.27,7.27,0,0,1-2.64.48,8.32,8.32,0,0,1-1.12-.09h0a7.65,7.65,0,0,1-1.55-.39,6.21,6.21,0,0,1-2.23-1.44,6.32,6.32,0,0,1,0-9.26,6.9,6.9,0,0,1,2.23-1.42,7.32,7.32,0,0,1,2.67-.5,6.86,6.86,0,0,1,4.9,1.92,6.2,6.2,0,0,1,2,4.65v12h5.76V24.07Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.17,24.07V25.9A12.85,12.85,0,0,0,95,24.16a10.91,10.91,0,0,0-2.08-.53,15,15,0,0,0-2.48-.2,12.1,12.1,0,0,0-4.78.94A11,11,0,0,0,81.86,27a11.61,11.61,0,0,0-2.42,3.83,12.63,12.63,0,0,0-.87,4.7v0a12,12,0,0,0,.91,4.66,11.78,11.78,0,0,0,6.42,6.41,12.54,12.54,0,0,0,4.87.93h.85a13.09,13.09,0,0,0,4.56-.91V40.11l0,0a6.75,6.75,0,0,1-2.25,1.44,7.35,7.35,0,0,1-2.64.48A8.06,8.06,0,0,1,90.14,42h0a7.49,7.49,0,0,1-1.55-.39,6.25,6.25,0,0,1-2.24-1.44,6.38,6.38,0,0,1-1.54-7.05c0-.07,0-.13.08-.19a6.54,6.54,0,0,1,1.46-2,7,7,0,0,1,2.24-1.42,7.32,7.32,0,0,1,2.67-.5,6.82,6.82,0,0,1,4.89,1.92,6.42,6.42,0,0,1,1.47,2c0,.06,0,.12.08.19a6.31,6.31,0,0,1,.47,2.44v9.13a6.13,6.13,0,0,1-2,4.61,7.06,7.06,0,0,1-8.35,1.05l-4.18,3.92a12.73,12.73,0,0,0,7.64,2.47,12.68,12.68,0,0,0,4.94-1,13.16,13.16,0,0,0,4-2.6A12.07,12.07,0,0,0,103,49.3a11.16,11.16,0,0,0,1-4.65V24.07Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.73,67.36v1.53H2V60.17H8.47V61.7H3.76v2.22h4V65.4H3.76v2Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.79,59.45v9.33H18.06v-.41a3.87,3.87,0,0,1-2,.52,3.48,3.48,0,0,1,0-7,4.07,4.07,0,0,1,2,.5v-3Zm-1.73,7.3v-2.7a2.59,2.59,0,0,0-1.65-.57,1.92,1.92,0,0,0-2,1.93,1.89,1.89,0,0,0,2,1.92A2.51,2.51,0,0,0,18.06,66.75Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.79,62.07v6.72H29.07v-.44a3.22,3.22,0,0,1-1.84.54c-2,0-2.87-.91-2.87-3.09V62.07h1.72V65.8c0,1,.51,1.55,1.46,1.55a2.3,2.3,0,0,0,1.53-.54V62.07Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.39,67.54a3.24,3.24,0,0,1-2.6,1.35,3.48,3.48,0,1,1,0-6.94,3.27,3.27,0,0,1,2.62,1.33l-1.11,1a1.84,1.84,0,0,0-1.51-.81,1.93,1.93,0,1,0,0,3.85,1.83,1.83,0,0,0,1.51-.83Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M52.42,62.07v6.72H50.7V68.3a3.55,3.55,0,0,1-2,.59,3.48,3.48,0,0,1,0-7,4,4,0,0,1,2,.55v-.42Zm-1.72,2A2.57,2.57,0,0,0,49,63.5a1.9,1.9,0,0,0-2,1.91,1.93,1.93,0,0,0,2,1.94,2.53,2.53,0,0,0,1.66-.57Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M59.17,63.5v2.37c0,1.2.2,1.55,1.06,1.55.3,0,.56,0,.8-.06v1.29a4.53,4.53,0,0,1-1.56.24,1.93,1.93,0,0,1-2-2.11V63.5h-1V62.07h1V59.46h1.74v2.61h1.88V63.5Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.16,60.44a1,1,0,0,1,1-1,1,1,0,0,1,1,1,1,1,0,0,1-1,1A1,1,0,0,1,65.16,60.44Zm.14,1.73H67v6.72H65.3Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.73,65.43A3.68,3.68,0,1,1,75.05,62,3.56,3.56,0,0,1,78.73,65.43Zm-1.69,0a2,2,0,1,0-2,1.92A2,2,0,0,0,77,65.43Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89.45,65.14v3.75H87.73V65.14c0-1-.5-1.55-1.46-1.55a2.17,2.17,0,0,0-1.48.54v4.76H83.07V62.17h1.72v.42a3.13,3.13,0,0,1,1.79-.54C88.55,62.05,89.45,63,89.45,65.14Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103,61.7v3.11h4.18v1.53H103v2.55h-1.72V60.17h6.58V61.7Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M118.94,65.43A3.69,3.69,0,1,1,115.26,62,3.57,3.57,0,0,1,118.94,65.43Zm-1.7,0a2,2,0,1,0-2,1.92A1.95,1.95,0,0,0,117.24,65.43Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.62,62.07v6.72H127.9v-.44a3.21,3.21,0,0,1-1.83.54c-2,0-2.87-.91-2.87-3.09V62.07h1.72V65.8c0,1,.5,1.55,1.46,1.55a2.25,2.25,0,0,0,1.52-.54V62.07Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140.67,65.14v3.75H139V65.14c0-1-.51-1.55-1.46-1.55a2.17,2.17,0,0,0-1.49.54v4.76h-1.72V62.17H136v.42a3.15,3.15,0,0,1,1.79-.54C139.76,62.05,140.67,63,140.67,65.14Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M152,59.45v9.33H150.3v-.41a3.85,3.85,0,0,1-2,.52,3.48,3.48,0,0,1,0-7,4.07,4.07,0,0,1,2,.5v-3Zm-1.73,7.3v-2.7a2.59,2.59,0,0,0-1.65-.57,1.92,1.92,0,0,0-2,1.93,1.89,1.89,0,0,0,2,1.92A2.51,2.51,0,0,0,150.3,66.75Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M163.43,62.07v6.72H161.7V68.3a3.49,3.49,0,0,1-2,.59,3.48,3.48,0,0,1,0-7,4,4,0,0,1,2,.55v-.42Zm-1.73,2a2.55,2.55,0,0,0-1.65-.58,1.93,1.93,0,1,0,0,3.85,2.52,2.52,0,0,0,1.65-.57Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M170.17,63.5v2.37c0,1.2.2,1.55,1.07,1.55.3,0,.56,0,.79-.06v1.29a4.4,4.4,0,0,1-1.56.24,1.93,1.93,0,0,1-2-2.11V63.5h-.95V62.07h.95V59.46h1.73v2.61h1.89V63.5Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M176.17,60.44a1,1,0,1,1,2,0,1,1,0,1,1-2,0Zm.13,1.73H178v6.72H176.3Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M189.74,65.43A3.69,3.69,0,1,1,186.06,62,3.57,3.57,0,0,1,189.74,65.43Zm-1.7,0a2,2,0,1,0-2,1.92A1.95,1.95,0,0,0,188,65.43Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M200.46,65.14v3.75h-1.72V65.14c0-1-.51-1.55-1.46-1.55a2.19,2.19,0,0,0-1.49.54v4.76h-1.72V62.17h1.72v.42a3.19,3.19,0,0,1,1.8-.54C199.56,62.05,200.46,63,200.46,65.14Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M198.17,136.69c0-1.46.65-3.09,2.29-3.09s2.3,1.63,2.3,3.09-.66,3.11-2.3,3.11S198.17,138.15,198.17,136.69Zm3.82,0c0-1.19-.38-2.43-1.53-2.43s-1.53,1.24-1.53,2.43.39,2.44,1.53,2.44S202,137.89,202,136.69Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M264.24,60.08c0-1.47.65-3.1,2.29-3.1s2.3,1.63,2.3,3.1-.66,3.11-2.3,3.11S264.24,61.54,264.24,60.08Zm3.82,0c0-1.2-.38-2.43-1.53-2.43S265,58.88,265,60.08s.39,2.44,1.53,2.44S268.06,61.28,268.06,60.08Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M266.61,34.59v-5l-1,1-.45-.46,1.5-1.55h.66v6Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M264.37,6.09v-.6c2.16-1.69,3.34-2.69,3.34-3.73A1.12,1.12,0,0,0,266.45.67a2,2,0,0,0-1.63.75L264.36,1A2.57,2.57,0,0,1,266.45,0a1.83,1.83,0,0,1,2,1.76c0,1.23-1.24,2.34-2.92,3.67h2.95v.66Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M172.19,139.69v-5l-1,1-.45-.46,1.5-1.55h.66v6Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M141.61,139.69v-.6c2.16-1.69,3.34-2.69,3.34-3.73a1.13,1.13,0,0,0-1.26-1.1,2,2,0,0,0-1.63.76l-.46-.48a2.58,2.58,0,0,1,2.09-.94,1.82,1.82,0,0,1,2,1.76c0,1.23-1.25,2.34-2.92,3.67h2.94v.66Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.18,138.81l.44-.47a2.07,2.07,0,0,0,1.67.79c.88,0,1.41-.44,1.41-1.12s-.61-1.06-1.5-1.06h-.62v-.69h.62c.76,0,1.4-.3,1.4-1s-.61-1-1.34-1a2.06,2.06,0,0,0-1.59.73l-.41-.47a2.57,2.57,0,0,1,2.06-.92c1.15,0,2,.58,2,1.59a1.46,1.46,0,0,1-1.29,1.4,1.52,1.52,0,0,1,1.39,1.48c0,1-.82,1.73-2.14,1.73A2.52,2.52,0,0,1,113.18,138.81Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M87.71,139.69v-1.52H84.85v-.62l2.58-3.86h1v3.82h.84v.66h-.84v1.52Zm0-5.31-2.11,3.13h2.11Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.67,138.84l.46-.51a2,2,0,0,0,1.66.8,1.29,1.29,0,0,0,1.38-1.28,1.27,1.27,0,0,0-1.38-1.3,1.89,1.89,0,0,0-1.38.56l-.55-.19v-3.23h3.67v.66H57.61v2.09a2,2,0,0,1,1.4-.54,1.84,1.84,0,0,1,1.92,1.92,2,2,0,0,1-2.14,2A2.48,2.48,0,0,1,56.67,138.84Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.18,136.69c0-1.62.76-3.09,2.45-3.09a2.06,2.06,0,0,1,1.66.72l-.38.56a1.54,1.54,0,0,0-1.28-.62c-1.17,0-1.69,1.18-1.69,2.36v.24a2.15,2.15,0,0,1,1.7-.94,1.81,1.81,0,0,1,2,1.92,2,2,0,0,1-2.09,2C28.82,139.8,28.18,138.33,28.18,136.69Zm3.67,1.17a1.24,1.24,0,0,0-1.38-1.29,1.83,1.83,0,0,0-1.5.89,1.59,1.59,0,0,0,1.5,1.67A1.3,1.3,0,0,0,31.85,137.86Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M.81,139.69l2.42-5.34H0v-.66H4.1v.51l-2.46,5.49Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 200.46,
    y1: 3.7,
    x2: 200.46,
    y2: 125.59
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 197.63,
    y1: 68.89,
    x2: 197.63,
    y2: 97.24
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 194.79,
    y1: 68.89,
    x2: 194.79,
    y2: 97.24
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 191.96,
    y1: 68.89,
    x2: 191.96,
    y2: 97.24
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 189.12,
    y1: 68.89,
    x2: 189.12,
    y2: 97.24
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 186.29,
    y1: 68.89,
    x2: 186.29,
    y2: 111.41
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 183.45,
    y1: 68.89,
    x2: 183.45,
    y2: 97.24
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 180.62,
    y1: 68.89,
    x2: 180.62,
    y2: 97.24
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 177.78,
    y1: 68.89,
    x2: 177.78,
    y2: 97.24
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 174.95,
    y1: 68.89,
    x2: 174.95,
    y2: 97.24
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 172.11,
    y1: 68.89,
    x2: 172.11,
    y2: 125.59
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 169.28,
    y1: 68.89,
    x2: 169.28,
    y2: 97.24
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 166.45,
    y1: 68.89,
    x2: 166.45,
    y2: 97.24
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 163.61,
    y1: 68.89,
    x2: 163.61,
    y2: 97.24
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 160.78,
    y1: 68.89,
    x2: 160.78,
    y2: 97.24
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 157.94,
    y1: 68.89,
    x2: 157.94,
    y2: 111.41
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 155.11,
    y1: 68.89,
    x2: 155.11,
    y2: 97.24
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 152.27,
    y1: 68.89,
    x2: 152.27,
    y2: 97.24
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 149.44,
    y1: 68.89,
    x2: 149.44,
    y2: 97.24
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 146.6,
    y1: 68.89,
    x2: 146.6,
    y2: 97.24
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 143.77,
    y1: 68.89,
    x2: 143.77,
    y2: 125.59
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 140.93,
    y1: 68.89,
    x2: 140.93,
    y2: 97.24
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 138.1,
    y1: 68.89,
    x2: 138.1,
    y2: 97.24
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 135.26,
    y1: 68.89,
    x2: 135.26,
    y2: 97.24
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 132.43,
    y1: 68.89,
    x2: 132.43,
    y2: 97.24
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 129.6,
    y1: 68.89,
    x2: 129.6,
    y2: 111.41
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 126.76,
    y1: 68.89,
    x2: 126.76,
    y2: 97.24
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 123.93,
    y1: 68.89,
    x2: 123.93,
    y2: 97.24
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 121.09,
    y1: 68.89,
    x2: 121.09,
    y2: 97.24
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 118.26,
    y1: 68.89,
    x2: 118.26,
    y2: 97.24
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 115.42,
    y1: 68.89,
    x2: 115.42,
    y2: 125.59
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 112.59,
    y1: 68.89,
    x2: 112.59,
    y2: 97.24
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 109.75,
    y1: 68.89,
    x2: 109.75,
    y2: 97.24
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 106.92,
    y1: 68.89,
    x2: 106.92,
    y2: 97.24
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 104.08,
    y1: 68.89,
    x2: 104.08,
    y2: 97.24
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 101.25,
    y1: 68.89,
    x2: 101.25,
    y2: 111.41
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 98.41,
    y1: 68.89,
    x2: 98.41,
    y2: 97.24
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 95.58,
    y1: 68.89,
    x2: 95.58,
    y2: 97.24
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 92.74,
    y1: 68.89,
    x2: 92.74,
    y2: 97.24
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 89.91,
    y1: 68.89,
    x2: 89.91,
    y2: 97.24
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 87.08,
    y1: 68.89,
    x2: 87.08,
    y2: 125.59
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 84.24,
    y1: 68.89,
    x2: 84.24,
    y2: 97.24
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 81.41,
    y1: 68.89,
    x2: 81.41,
    y2: 97.24
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 78.57,
    y1: 68.89,
    x2: 78.57,
    y2: 97.24
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 75.74,
    y1: 68.89,
    x2: 75.74,
    y2: 97.24
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.9,
    y1: 68.89,
    x2: 72.9,
    y2: 111.41
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.07,
    y1: 68.89,
    x2: 70.07,
    y2: 97.24
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 67.23,
    y1: 68.89,
    x2: 67.23,
    y2: 97.24
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.4,
    y1: 68.89,
    x2: 64.4,
    y2: 97.24
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 61.56,
    y1: 68.89,
    x2: 61.56,
    y2: 97.24
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 58.73,
    y1: 68.89,
    x2: 58.73,
    y2: 125.59
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 55.89,
    y1: 68.89,
    x2: 55.89,
    y2: 97.24
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 53.06,
    y1: 68.89,
    x2: 53.06,
    y2: 97.24
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 50.23,
    y1: 68.89,
    x2: 50.23,
    y2: 97.24
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 47.39,
    y1: 68.89,
    x2: 47.39,
    y2: 97.24
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 44.56,
    y1: 68.89,
    x2: 44.56,
    y2: 111.41
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 41.72,
    y1: 68.89,
    x2: 41.72,
    y2: 97.24
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 38.89,
    y1: 68.89,
    x2: 38.89,
    y2: 97.24
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 36.05,
    y1: 68.89,
    x2: 36.05,
    y2: 97.24
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 33.22,
    y1: 68.89,
    x2: 33.22,
    y2: 97.24
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 30.38,
    y1: 68.89,
    x2: 30.38,
    y2: 125.59
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 27.55,
    y1: 68.89,
    x2: 27.55,
    y2: 97.24
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 24.71,
    y1: 68.89,
    x2: 24.71,
    y2: 97.24
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 21.88,
    y1: 68.89,
    x2: 21.88,
    y2: 97.24
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 19.04,
    y1: 68.89,
    x2: 19.04,
    y2: 97.24
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 16.21,
    y1: 68.89,
    x2: 16.21,
    y2: 111.41
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 13.37,
    y1: 68.89,
    x2: 13.37,
    y2: 97.24
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 10.54,
    y1: 68.89,
    x2: 10.54,
    y2: 97.24
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 7.71,
    y1: 68.89,
    x2: 7.71,
    y2: 97.24
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 4.87,
    y1: 68.89,
    x2: 4.87,
    y2: 97.24
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2.04,
    y1: 3.7,
    x2: 2.04,
    y2: 125.59
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2.04,
    y1: 3.7,
    x2: 257.15,
    y2: 3.7
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 200.46,
    y1: 6.53,
    x2: 228.81,
    y2: 6.53
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 200.46,
    y1: 9.37,
    x2: 228.81,
    y2: 9.37
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 200.46,
    y1: 12.2,
    x2: 228.81,
    y2: 12.2
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 200.46,
    y1: 15.04,
    x2: 228.81,
    y2: 15.04
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 200.46,
    y1: 17.87,
    x2: 242.98,
    y2: 17.87
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 200.46,
    y1: 20.71,
    x2: 228.81,
    y2: 20.71
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 200.46,
    y1: 23.54,
    x2: 228.81,
    y2: 23.54
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 200.46,
    y1: 26.37,
    x2: 228.81,
    y2: 26.37
  })), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 200.46,
    y1: 29.21,
    x2: 228.81,
    y2: 29.21
  })), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 200.46,
    y1: 32.04,
    x2: 257.15,
    y2: 32.04
  })), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 200.46,
    y1: 34.88,
    x2: 228.81,
    y2: 34.88
  })), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 200.46,
    y1: 37.71,
    x2: 228.81,
    y2: 37.71
  })), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 200.46,
    y1: 40.55,
    x2: 228.81,
    y2: 40.55
  })), _line84 || (_line84 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 200.46,
    y1: 43.38,
    x2: 228.81,
    y2: 43.38
  })), _line85 || (_line85 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 200.46,
    y1: 46.22,
    x2: 242.98,
    y2: 46.22
  })), _line86 || (_line86 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 200.46,
    y1: 49.05,
    x2: 228.81,
    y2: 49.05
  })), _line87 || (_line87 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 200.46,
    y1: 51.89,
    x2: 228.81,
    y2: 51.89
  })), _line88 || (_line88 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 200.46,
    y1: 54.72,
    x2: 228.81,
    y2: 54.72
  })), _line89 || (_line89 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 200.46,
    y1: 57.56,
    x2: 228.81,
    y2: 57.56
  })), _line90 || (_line90 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 200.46,
    y1: 60.39,
    x2: 257.15,
    y2: 60.39
  })), _line91 || (_line91 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 200.46,
    y1: 63.22,
    x2: 228.81,
    y2: 63.22
  })), _line92 || (_line92 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 200.46,
    y1: 66.06,
    x2: 228.81,
    y2: 66.06
  })), _line93 || (_line93 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2.04,
    y1: 68.89,
    x2: 228.81,
    y2: 68.89
  })), _line94 || (_line94 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2.04,
    y1: 9.37,
    x2: 3.04,
    y2: 9.37
  })), _line95 || (_line95 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5.02,
    y1: 9.37,
    x2: 198.47,
    y2: 9.37
  })), _line96 || (_line96 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 199.46,
    y1: 9.37,
    x2: 200.46,
    y2: 9.37
  })), _line97 || (_line97 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2.04,
    y1: 15.04,
    x2: 3.04,
    y2: 15.04
  })), _line98 || (_line98 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5.02,
    y1: 15.04,
    x2: 198.47,
    y2: 15.04
  })), _line99 || (_line99 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 199.46,
    y1: 15.04,
    x2: 200.46,
    y2: 15.04
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPls2);
export default __webpack_public_path__ + "static/media/pls2.ee029458f1f827a53abb835811871eb7.svg";
export { ForwardRef as ReactComponent };